export default "__VITE_ASSET__Cjn77iCB__"